import axios from "./axiosConfig";

export function getTransactionData(transactionId) {
    return axios.get('/api/v1/transactions/' + transactionId)
        .then((response) => {
            // handle success
            return response;
        })
        .catch((error) => {
            console.log('error---->>>', error);
            return error;
        });
}

export function getTransactionsList() {
    return axios.get('/api/v1/transactions-per-user')
        .then((response) => {
            // handle success
            return response.data;
        })
        .catch((error) => {
            // handle error
            return error;
        });
}

/**
 * initiate transaction txnToken & orderId
 * @param data
 * @returns {response}
 */
 export function getTransactionToken (data) {
    return axios.post('/api/v2/initiate-transaction', data)
        .then((response) => {
            // handle success
            return response.data;
        })
        .catch((error) => {
            return error;
        });
};